import {
    put, takeLatest, all, PutEffect,
} from "redux-saga/effects";
import axios, {AxiosResponse} from "axios";
import {safeSaga} from "@data-force/app";
import {setDatepickerTranslation} from "../actions/antdTranslation";
import {
    GetDatepickerTranslationAction,
    SetDatepickerTranslationAction,
} from "../../interfaces/store/actions/antdTranslation";
import {TranslationJson} from "../../interfaces/translationJson";
import {GET_DATEPICKER_TRANSLATION} from "../actions/availableActions";

type GetDatepickerTranslationHandlerGenerator = Generator<Promise<AxiosResponse<TranslationJson>>
| PutEffect<SetDatepickerTranslationAction>, void, AxiosResponse<TranslationJson>>;

function* getDatepickerTranslationHandler(
    {payload}: GetDatepickerTranslationAction,
): GetDatepickerTranslationHandlerGenerator {
    const {data}: AxiosResponse<TranslationJson> = yield axios.get(`/i18n/antd/${payload}.json`);
    yield put(setDatepickerTranslation(data.DatePicker));
}

export function* actionWatcher() {
    yield all([
        takeLatest(GET_DATEPICKER_TRANSLATION, safeSaga(getDatepickerTranslationHandler)),
    ]);
}
